import { render } from "./AddPrixProduitCondTypeClientPage2.vue?vue&type=template&id=0fb1c9fa&ts=true"
import script from "./AddPrixProduitCondTypeClientPage2.vue?vue&type=script&lang=ts"
export * from "./AddPrixProduitCondTypeClientPage2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__